import { inject,  provideAppInitializer } from '@angular/core'

import { OperatorData } from '@definitions/operator-data'
import { OperatorDataState } from '@states/operator-data'
import { STORAGE_KEYS, getLocalStorage } from '@utils/storage'

export const operatorDataFactory = provideAppInitializer(() => {
	const operatorDataState = inject(OperatorDataState)
	const operatorDataStorage = getLocalStorage<OperatorData>(STORAGE_KEYS.AUTH)

	operatorDataState.operatorData.set(operatorDataStorage)
})
